import apiClient from "./APIClient";

const notificationService = {
  
  async registerPushToken(data) {
    try {
      const response = await apiClient.post('/notifications/register-push-token', data);
      return response.data;
    } catch (error) {
      console.error('Push token registration failed:', error);
      throw error;
    }
  },


  async getUserNotifications(params = {}) {
    try {
      const response = await apiClient.get('/notifications/user', { params });
      return response.data;
    } catch (error) {
      console.error('Get notifications failed:', error);
      throw error;
    }
  },


  async markAsRead(notificationId) {
    try {
      const response = await apiClient.post(`/notifications/${notificationId}/read`);
      return response.data;
    } catch (error) {
      console.error('Mark as read failed:', error);
      throw error;
    }
  },


  async markAllAsRead() {
    try {
      const response = await apiClient.post('/notifications/mark-all-read');
      return response.data;
    } catch (error) {
      console.error('Mark all as read failed:', error);
      throw error;
    }
  },


  async sendTestPush(data) {
    try {
      const response = await apiClient.post('/notifications/test-push', data);
      return response.data;
    } catch (error) {
      console.error('Test push failed:', error);
      throw error;
    }
  }
};

export default notificationService;